import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";
import { FaMedal} from "react-icons/fa6";
import ApprovalAwards from "./index";
import { MODULE_APPROVAL_AWARDS } from "variables/constants";

const approvalAwardRoutes = [	
    generateCRUDRoutes({
        mainTitle: "Approval Awards",
        basePath: "approval-awards",
        mainComponent: <ApprovalAwards />,
        layout: "/console",	   
        icon: <FaMedal className="icon-item" />,
        subTitle:"Approval Awards",
        level:5,
        moduleId: MODULE_APPROVAL_AWARDS,
    })
]

export default approvalAwardRoutes;